export default __webpack_public_path__ + "static/media/celebrate.2ecb0e7271a8efa731d44472ba08ad20.svg";